import { styled } from 'linaria/react';

export const ProductCardMobileReviewsFormContainer = styled.div`
  box-shadow: var(--box-shadow-s);
  border-radius: var(--rounding-m);
  padding: var(--space-200);

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--space-200);
`;
